<template>
  <v-card
    class="mb-3 rounded-lg pwt-hover-container"
    @click="showTrip"
    :loading="fetching"
    :disabled="fetching"
    elevation="3"
    color="pwt_snow"
  >
    <v-row no-gutters align="center">
      <v-col cols="12">
        <!-- <v-col :cols="trip.frequency ? 8 : 12"> -->
        <v-card-title>
          <span class="text-truncate pwt-hover-underline">
            {{ displayName }}
          </span>
        </v-card-title>
      </v-col>
      <!-- <v-col v-if="trip.frequency" cols="4" class="text-right pr-3">
        <v-icon color="primary" v-if="trip.frequency"> mdi-progress-clock </v-icon>
        <span class="pr-2 text-truncate" v-if="trip.frequency">
          {{ trip.frequency?.numberOfTimes }}x {{ trip.frequency?.timeFrame }}
        </span>
      </v-col> -->
    </v-row>
    <v-card-text>
      <ul style="list-style: none; padding-left: unset">
        <li>{{ niceDuration(trip.itinerary.totalTime) }}</li>
        <li class="d-flex justify-space-between">
          <!-- {{ trip.chargingStopCDBIDs.length }} charging stops -->
          <CustomOutlinedButton @click="showDialog = true">
            Delete
          </CustomOutlinedButton>
        </li>
      </ul>
    </v-card-text>
    <v-dialog max-width="500" v-model="showDialog">
      <v-card flat style="height: 100%" class="bg-transparent">
        <v-card-text v-if="status === 'PROCESSING'" class="text-primary">
          <v-progress-circular :width="3" indeterminate color="primary" />
          Processing...
        </v-card-text>
        <v-card-text v-else-if="status === 'SUCCESS'" class="text-success">
          <v-icon color="success"> mdi-check-circle </v-icon>
          Deleted successfully.
        </v-card-text>
        <v-card-text v-else-if="status === 'FAILED'" class="text-error">
          <v-icon color="error"> mdi-alert-circle </v-icon>
          Whoops! Something went wrong and this trip was not deleted.
        </v-card-text>
        <v-card-text v-else>
          Are you sure you want to delete your trip, {{ displayName }}. This can
          not be undone.
        </v-card-text>
        <v-card-actions>
          <CustomSolidButton @click="handleDelete" v-if="status === undefined">
            Delete
          </CustomSolidButton>
          <CustomSolidButton
            @click="closeDialog"
            v-else-if="status !== 'PROCESSING'"
          >
            Ok
          </CustomSolidButton>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script setup lang="ts">
import CustomOutlinedButton from "@/components/ui-elements/buttons/custom-buttons/CustomOutlinedButton.vue";
import CustomSolidButton from "@/components/ui-elements/buttons/custom-buttons/CustomSolidButton.vue";
import { useTripStore, type Trip } from "@/domains/trips";
import { getNiceDuration } from "@/utils/timeUtils";
import { computed, ref } from "vue";

const emit = defineEmits<{
  (e: "view-trip", value: Trip): void;
}>();

const tripStore = useTripStore();

const { trip, emitOnly = false } = defineProps<{
  trip: Trip;
  emitOnly?: boolean;
}>();

const displayName = computed(() => {
  if (trip.name) return trip.name;

  const lastLocation = trip.locations?.[trip.locations.length - 1];
  if (lastLocation) {
    return `Trip to ${lastLocation.address}`;
  }

  return "Unnamed Trip";
});

const fetching = computed(() => tripStore.isFetching);

function niceDuration(seconds: number): string {
  return getNiceDuration(seconds);
}

function showTrip() {
  if (emitOnly) {
    emit("view-trip", trip);
  } else {
    tripStore.showTrip(trip.id);
  }
}

const showDialog = ref(false);
const status = ref<"PROCESSING" | "SUCCESS" | "FAILED" | undefined>(undefined);
function closeDialog() {
  showDialog.value = false;
  status.value = undefined;
}

async function handleDelete() {
  status.value = "PROCESSING";

  const result = await tripStore.deleteTrip(trip.id);

  status.value = result.success ? "SUCCESS" : "FAILED";

  if (result.success) {
    setTimeout(() => {
      closeDialog();
      tripStore.removeTrip(trip.id);
    }, 1500);
  }
}
</script>
<style scoped>
.pwt-hover-container:hover .pwt-hover-underline {
  text-decoration: underline;
}
</style>
